
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const CheckIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 17-4-4M19 7 9 17"/></svg>
  </SvgIcon>
);
